import ApiHelpers from '@/data/dao/base/ApiHelpers';
import StatsForm from '@/data/models/StatsForm';
import StatsConsumptionForm from '@/data/models/StatsConsumptionForm';
import StatsConsumptionResponse from '@/data/models/StatsConsumptionResponse';
import StatsConsumptionDistributionResponse from '../models/StatsConsumptionDistributionResponse';
import ModelResultDailyAggregated from "@/data/models/model-result-daily-aggregated";
import GetTemperatureDataForm from "@/data/models/getTemperatureDataForm";
import dayjs from 'dayjs';

export default class DashboardDao {
  static getEnergeticSignatureStats(data: StatsForm): Promise<StatsConsumptionResponse<ModelResultDailyAggregated>[]> {
    return ApiHelpers
      .post<StatsConsumptionResponse<ModelResultDailyAggregated>[]>(`/stats/energeticSignature`, data.toJSON())
      .then((data) => data.map((it) => StatsConsumptionResponse.map(it)))
      .then((data) => {
        // Sort values by date
        data.forEach((it) => it.values.sort((a, b) => dayjs(a.date).isBefore(dayjs(b.date)) ? -1 : 1));
        return data;
      });
  }

  static getConsumptionStats<T>(data: StatsConsumptionForm): Promise<StatsConsumptionResponse<T>[]> {
    return ApiHelpers
      .post<StatsConsumptionResponse<T>[]>(`/stats/consumptions`, data.toJSON())
      .then((data) => data.map((it) => StatsConsumptionResponse.map(it)));
  }

  /**
   * Index bruts (idx_conso) des compteurs sur le même intervalle que l'analyse (même formulaire que les consommations)
   */
  static getIndexStats<T>(data: StatsConsumptionForm): Promise<StatsConsumptionResponse<T>[]> {
    return ApiHelpers
      .post<StatsConsumptionResponse<T>[]>(`/stats/indexes`, data.toJSON())
      .then((data) => data.map((it) => StatsConsumptionResponse.map(it)));
  }

  /**
   * Indique si des index bruts existent pour les compteurs sur l'intervalle de l'analyse (sans charger les valeurs)
   */
  static hasIndexStats(data: StatsConsumptionForm): Promise<boolean> {
    return ApiHelpers
      .post<{ state: boolean }>(`/stats/indexes/available`, data.toJSON())
      .then((result) => result?.state === true);
  }

  static getTemperatureData<T>(data: GetTemperatureDataForm): Promise<StatsConsumptionResponse<T>> {
    return ApiHelpers
      .post<StatsConsumptionResponse<T>[]>(`/stats/temperatureData`, data.toJSON())
      .then((data) => StatsConsumptionResponse.map(data?.pop() ?? null));
  }

  static getConsumptionDistributionStats(data: StatsConsumptionForm): Promise<StatsConsumptionDistributionResponse[]> {
    return ApiHelpers
      .post<StatsConsumptionDistributionResponse[]>(`/stats/consumptionsDistribution`, data.toJSON())
      .then((data) => data.map((it) => StatsConsumptionDistributionResponse.map(it)));
  }
}
